import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { UPLOAD_ATTACHMENT } from './queries';
import { Dropzone, MultiDropzone, AssetDocumentsDropzone } from '../../elements/Dropzone';
import { TitleContainer, ContainerTitle } from '../../elements';
import { View } from 'react-native';
import { ButtonContainer } from './elements';
import { ButtonGroup, Button } from '../../elements/buttons';

const NewAttachment = (props) => {
  const {
    recordId,
    recordType,
    setShowModal,
    attachmentType,
    updateAttachments,
    setValue
  } = props;
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [file, setFile] = useState();
  const [files, setFiles] = useState();
  const [uploadAttachment] = useMutation(UPLOAD_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        updateAttachments(
          attachmentType,
          'add',
          response.uploadAttachment.attachment
        )
      }
    }
  );

  let name = 'photos';
  if ('Document' === attachmentType) {
    name = 'documents';
  }

  const handleSubmit = () => {
    setFormSubmitting(true)
    if (file) {
      uploadAttachment(
        {variables: { recordType, recordId, file, name, primary: false }}
      )
    }
  }

  const handleFile = (file) => {
    setFile(file)
    if(attachmentType === 'Title Log') {
      setValue('upload', file);
    }
  }

  return (
    <View>
      <Dropzone
        accept={getAccepted()}
        description="Drag and drop files here, or click to choose files."
        handleFile={handleFile}
      />
      {attachmentType !== 'Title Log' && attachmentType !== 'Expense File' &&
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function getAccepted() {
    let accepted = ".jpeg, .jpg, .png, .heic";
    if(attachmentType === 'Seller Document') {
      accepted += ".pdf, .xls, .xlsx, .doc, .docx";
    }

    return accepted;
  }
}

export default NewAttachment;

export const NewAttachments = (props) => {
  const {
    recordId,
    recordType,
    setShowModal,
    attachmentType,
    updateAttachments,
    setValue
  } = props;
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [files, setFiles] = useState(props.existingFiles || []);
  const [uploadAttachment] = useMutation(UPLOAD_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        updateAttachments(
          attachmentType,
          'add',
          response.uploadAttachment.attachment
        )
      }
    }
  );

  let name = 'photos';
  if ('Seller Document' === attachmentType) {
    name = 'sellerDocuments';
  }

  const handleSubmit = () => {
    setFormSubmitting(true)
    uploadAttachment(
      {variables: { recordType, recordId, file, name, primary: false }}
    )
  }

  const handleFiles = (files) => {
    setFiles(files)
    // if(attachmentType === 'Expense File') {
      // setValue('expenseFiles', files);
    // }
    setValue(props.name, files)
  }

  return (
    <View style={{maxWidth: '70vw'}}>
      <MultiDropzone
        accept={getAccepted()}
        description="Drag and drop files here, or click to choose files."
        handleFiles={handleFiles}
        files={files}
        setFiles={setFiles}
      />
      {/* {attachmentType !== 'Title Log' && attachmentType !== 'Expense File' && */}
      { !['Seller Document'].includes(attachmentType) &&
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function getAccepted() {
    let accepted = ".jpeg, .jpg, .png, .heic";
    if(attachmentType === 'Seller Document') {
      accepted += ".pdf, .xls, .xlsx, .doc, .docx";
    }

    return accepted;
  }
}

export const NewAssetDocuments = (props) => {
  const {
    recordId,
    recordType,
    setShowModal,
    attachmentType,
    updateAttachments,
    setValue
  } = props;
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [files, setFiles] = useState(props.existingFiles || []);
  const [fileNotes, setFileNotes] = useState(props.existingFileNotes || []);
  const [uploadAttachment] = useMutation(UPLOAD_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        updateAttachments(
          attachmentType,
          'add',
          response.uploadAttachment.attachment
        )
      }
    }
  );

  let name = 'photos';
  if ('Seller Document' === attachmentType) {
    name = 'sellerDocuments';
  }

  const handleSubmit = () => {
    setFormSubmitting(true)
    uploadAttachment(
      {variables: { recordType, recordId, file, name, primary: false }}
    )
  }

  const handleFiles = (files) => {
    setFiles(files)
    setFileNotes(fileNotes)
    // if(attachmentType === 'Expense File') {
      // setValue('expenseFiles', files);
    // }
    setValue(props.name, files)
  }

  return (
    <View style={{maxWidth: '70vw'}}>
      <AssetDocumentsDropzone
        accept={getAccepted()}
        description="Drag and drop files here, or click to choose files."
        handleFiles={handleFiles}
        files={files}
        fileNotes={fileNotes}
        setFiles={setFiles}
        setFileNotes={setFileNotes}
      />
      {/* {attachmentType !== 'Title Log' && attachmentType !== 'Expense File' && */}
      { !['Seller Document'].includes(attachmentType) &&
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function getAccepted() {
    let accepted = ".jpeg, .jpg, .png, .heic";
    if(attachmentType === 'Seller Document') {
      accepted += ".pdf, .xls, .xlsx, .doc, .docx";
    }

    return accepted;
  }
}
